/**
 * @ngdoc directive
 * @name ng-colorgrade
 * @description
 * This service manages color grades
 */
export let ColorGradeDirective = () => ({
  link: (_, element) => {
    let newColor = element[0].innerHTML;
    let hsl = 'hsl(' + newColor + ',100%,50%)';
    element[0].style.backgroundColor = hsl;
    element[0].innerHTML = '';
  },
});

export default 'colorgrade';
